import React from 'react'

const QuestionCircle = ({ className = '' }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_219_3103)">
        <path
          d="M7 13.125C5.37555 13.125 3.81763 12.4797 2.66897 11.331C1.52031 10.1824 0.875 8.62445 0.875 7C0.875 5.37555 1.52031 3.81763 2.66897 2.66897C3.81763 1.52031 5.37555 0.875 7 0.875C8.62445 0.875 10.1824 1.52031 11.331 2.66897C12.4797 3.81763 13.125 5.37555 13.125 7C13.125 8.62445 12.4797 10.1824 11.331 11.331C10.1824 12.4797 8.62445 13.125 7 13.125ZM7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14Z"
          fill="#838992"
        />
        <path
          d="M4.59833 5.06275C4.59713 5.09101 4.60173 5.11921 4.61183 5.14563C4.62194 5.17204 4.63734 5.19611 4.65709 5.21636C4.67684 5.2366 4.70053 5.25259 4.72669 5.26334C4.75285 5.27409 4.78093 5.27938 4.80921 5.27887H5.53108C5.65183 5.27887 5.74808 5.18 5.76383 5.06012C5.84258 4.48612 6.23633 4.06788 6.93808 4.06788C7.53833 4.06788 8.08783 4.368 8.08783 5.08987C8.08783 5.6455 7.76058 5.901 7.24346 6.2895C6.65458 6.71738 6.18821 7.217 6.22146 8.02813L6.22408 8.218C6.225 8.27541 6.24845 8.33015 6.28938 8.37042C6.3303 8.41069 6.38542 8.43326 6.44283 8.43325H7.15246C7.21047 8.43325 7.26611 8.4102 7.30714 8.36918C7.34816 8.32816 7.37121 8.27252 7.37121 8.2145V8.12262C7.37121 7.49438 7.61008 7.3115 8.25496 6.82237C8.78783 6.41725 9.34346 5.9675 9.34346 5.02338C9.34346 3.70125 8.22696 3.0625 7.00458 3.0625C5.89596 3.0625 4.68146 3.57875 4.59833 5.06275ZM5.96071 10.1054C5.96071 10.5717 6.33258 10.9165 6.84446 10.9165C7.37733 10.9165 7.74396 10.5717 7.74396 10.1054C7.74396 9.62238 7.37646 9.28288 6.84358 9.28288C6.33258 9.28288 5.96071 9.62238 5.96071 10.1054Z"
          fill="#838992"
        />
      </g>
      <defs>
        <clipPath id="clip0_219_3103">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default QuestionCircle
